import { Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';

import { EntityList } from '@common/model';
import { ApiService } from '@common/services/api.service';

import { BranchDto } from './models/branch.dto';

@Injectable({
  providedIn: 'root'
})
export class FboMonolithBranchDataService {

  private branchList: BranchDto[] = [];

  constructor(
    private apiService: ApiService
  ) { }

  public getBranchList(): Observable<BranchDto[]> {
    if (this.branchList.length) {
      return of(this.branchList);
    }

    const oDataParams = oreq
      .request()
      .withSelect(['Id', 'Name', 'IsActive'])
      .url();
    return this.apiService.query<EntityList<BranchDto>>(`branch/list?${oDataParams}&`).pipe(
      map(branchResponse => branchResponse.Items),
      tap(branches => this.branchList = branches)
    );
  }

}
